<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
  <span i18n='Club section title@@tixxSelect.sectionHeading.processConfiguration' class="esf-action-heading__text">Process Configuration</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple"
              (click)="editProcessConfiguration();$event.stopPropagation();"
              [disabled]="!(selectedLottery.isDraftMode || selectedLottery.isEditMode)"
              [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile" style="flex: 1;">
  <div class="esf-info-tile__content" *ngIf="!spinnerLoading">
    <small>
      <span class="secondary-request">
        <strong i18n="@@tixxSelect.processConfiguration.secondaryRequest">Secondary request</strong>: {{ getTranslatedKey(processConfiguration.secondaryTicketRequestAvailable) }}
      </span><br>
    </small>
    <small>
      <span class="price-deviation">
        <strong i18n="@@tixxSelect.processConfiguration.possiblePriceDeviation">Possible Price Deviation</strong>: {{ getTranslatedKey(processConfiguration.possiblePriceDeviation) }}
      </span><br>
    </small>
    <small>
      <span class="optional-non-contigous">
        <strong i18n="@@tixxSelect.processConfiguration.optionalNonContigous">Optional non-contigous</strong>: {{ getTranslatedKey(processConfiguration.optionalNonContiguousSeating) }}
      </span><br>
    </small>
    <small>
      <span class="deletable-self-service">
        <strong i18n="@@tixxSelect.processConfiguration.deletableSelfService">Deletable self-service</strong>: {{ getTranslatedKey(processConfiguration.submissionsWithdrawableByOwner) }}
      </span><br>
    </small>
    <!-- <small>
      <span class="ticket-personalization">
        <strong i18n="@@tixxSelect.processConfiguration.ticketPersonalization">Ticket personalization</strong>: {{ getTranslatedKey(processConfiguration.ticketPersonalizationEnabled) }}
      </span><br>
    </small> -->
    <small>
      <span class="show-tickets">
        <strong i18n="@@tixxSelect.processConfiguration.showPrices">Show prices</strong>: {{ getTranslatedKey(processConfiguration.showPrices) }}
      </span><br>
    </small>
    <small>
      <span class="show-tickets">
        <strong i18n="@@tixxSelect.processConfiguration.deliveryPaymentMethod">Delivery & Payment method</strong>: {{ getTranslatedKey(processConfiguration.orderRequestRequired) }}
      </span><br>
    </small>
    <small>
      <span class="delivery-methods">
        <strong i18n="@@tixxSelect.processConfiguration.deliveryType">Delivery type</strong>: {{ processConfiguration.delivery.translatedDelivery }}
      </span><br>
    </small>
    <div class="esf-icon-and-text esf-icon-and-text--xs"
         *ngIf="processConfiguration.submissionCollectionTiming.start && processConfiguration.submissionCollectionTiming.deadline">
      <svg class="esf-icon" width="16" height="16">
        <use xlink:href="#esf-icon-clock"></use>
      </svg>
      <span class="esf-icon-and-text__text date">
        {{ processConfiguration.submissionCollectionTiming.start.date | date:processConfiguration.submissionCollectionTiming.start.format}}
        -
        {{ processConfiguration.submissionCollectionTiming.deadline.date | date:processConfiguration.submissionCollectionTiming.deadline.format}}
      </span>
    </div>
  </div>

  <section class="esf-empty-state flex-empty-state" *ngIf="spinnerLoading">
    <app-spinner [name]="spinnerName" [(show)]="spinnerLoading"></app-spinner>
  </section>
</div>
